export enum CalculationConfigRenovationKeyEnum {
  // todo
}
